<ngx-spinner color="#022f53"></ngx-spinner>
<router-outlet></router-outlet>
